export default function AboutSection() {
  return (
    <section className="py-20 bg-background">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-3xl font-semibold text-foreground">
          Your Trusted Partner in Integrated Healthcare
        </h2>

        <p className="mt-6 text-muted-foreground max-w-3xl">
          Medigenix Health delivers a complete ecosystem of clinical care,
          wellness programs, and digital tools that empower individuals to take
          control of their health. Our patient-first platform simplifies medical
          access with clarity, convenience, and trust.
        </p>
      </div>
    </section>
  );
}
